import styled from "@emotion/styled";
import {  Form, Typography } from "antd";
import { Dispatch, FC, ReactNode, SetStateAction } from "react";
import PaymentChannelForm from "./PaymentChannelForm";

interface MainCreateOrderPaymentProps {
  childrenBank: ReactNode[];  
  switchOn: boolean
  // setSwitchOn?:  Dispatch<boolean>
  paymentDate: Date | null;
  setPaymentDate: Dispatch<SetStateAction<Date | null>>
}

const MainCreateOrderPayment: FC<MainCreateOrderPaymentProps> = ({ childrenBank, switchOn, paymentDate, setPaymentDate
}) => {
  return (
    <>
    <FormWrapper>
      <FormItemWrapper>
        <HeadWrapper>
          <Typography.Text 
            style={{
              fontWeight: 600,
            }}
            underline >การชำระสินค้า</Typography.Text>
        </HeadWrapper>
        <PaymentChannelForm 
          childrenBank={childrenBank}
          switchOn={switchOn}
          // setSwitchOn={setSwitchOn}
          paymentDate={paymentDate}
          setPaymentDate={setPaymentDate}
        />
        {/* <Divider/>
        <DeliveryRemarkForm/> */}
      </FormItemWrapper>
    </FormWrapper>
  </>
  );
};

export default MainCreateOrderPayment;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffffff;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0px 10px 0px 10px;
`;


const FormItemWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px 0px 10px 0px;
  border-radius: 10px;
`;
